import { Component, Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { HostListenerService } from '../../../../services/host-listener.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-info-tooltip',
    template: `
        <mat-icon #tooltip="matTooltip"
                  [matTooltipClass]="'wide-tooltip'"
                  [matTooltip]="matTooltip"
                  [svgIcon]="'v2:fi-br-info'"
                  (click)="isMobileMode ? tooltip.toggle() : null">>
        </mat-icon>
    `,
    standalone: true,
    imports: [
        MatIconModule,
        MatTooltipModule,
        AsyncPipe,
        NgIf,
    ],
})
export class InfoTooltipComponent implements OnInit
{
    @Input() matTooltip: string;
    @ViewChild(MatIcon, { read: ElementRef, static: true }) icon: ElementRef;

    isMobileMode = false;

    constructor(private _host: HostListenerService) {
    }

    ngOnInit() {
        this._host.isMobileMode().pipe(untilDestroyed(this)).subscribe((isMobileMode) => {
            this.isMobileMode = isMobileMode;
        });
    }
}

@Directive({
    selector: '[infoTooltip]',
    standalone: true,
})
export class InfoTooltipDirective implements OnChanges
{
    @Input('infoTooltip') matTooltip: string | undefined;

    constructor(
            private _vcr: ViewContainerRef,
            private _tpl: TemplateRef<any>,
            private _renderer: Renderer2,
    ){
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('matTooltip')) {
            this._vcr.clear();

            const embedded = this._vcr.createEmbeddedView(this._tpl);
            this.appendIconWithTooltip(embedded.rootNodes.at(0));
        }
    }

    private appendIconWithTooltip(node: any) {
        const componentRef = this._vcr.createComponent(InfoTooltipComponent);
        componentRef.setInput('matTooltip', this.matTooltip);
        this._renderer.appendChild(node, componentRef.instance.icon.nativeElement);
    }
}
